const _ = require('lodash');

export function getItem(key) {
    return !_.isEmpty(localStorage.getItem(key)) ?  JSON.parse(localStorage.getItem(key)) : '';
}

export function setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

export function removeItem(key) {
    localStorage.removeItem(key);
}

export function clearAll(){
    localStorage.clear();
}
